import {rootActions, useAppDispatch, useAppSelector} from '../../data-services/store';
import {ProductsRelDocs} from "../../interfaces";
import {ProductDepartmentEnum} from "../../../enums/product-department-enum";
import {sendGAEventAddToCart} from "../../../../../domain/marketing/gtm-provider";
import ProductPriceFormat from "../../../product-price/product-price-format";
import {outbrainAddToCartEvent} from "../../../../../domain/marketing/outbrain-provider";
import ProductSubscribeButtonABTEST from "../../../subscription/sbs-subscibe-button-abtest";
import { useEffect, useState } from "react";
import {PlansPopupExported} from "../../../../subscriptions/components/plugins-popup/plans-popup-exported";
import {
    abtest_ProductListPricingAreaVariants,
    IListItem
} from "../../../../list-page/interfaces/interfaces";
import PRDNeedHelpDeciding from "./prd-need-help-decidng";
import ProductAskWavesBtn from '../ask-waves/product-ask-waves-btn';
import { getABTest, sendABTestAnalytics } from '../../../../../domain/abtest/abtest-provider';

interface IProductBuyButtonProps {
    product: ProductsRelDocs,
    isPriceDifferent? :boolean
}
/**
 * the entry point
 */
const PRDAddToCart = (props: IProductBuyButtonProps) => {
    const [showSubscriptionPopup, setShowSubscriptionPopup] = useState(false);
    const [showAskWaves, setShowAskWaves] = useState(false);

    const dispatch = useAppDispatch();
    const product = props.product;

    const isProductNote = !product.skuEnabled && product.note !== null && product.note !== '';
    //console.log('PRDAddToCart: ',product);

    const productPageUpgradeLink = useAppSelector((store) => store.productPageUpgradeLink);
    const abtest_ProductListPricingArea = useAppSelector((store) => store.abtest_ProductListPricingArea);
    //console.log('abtest_ProductListPricingArea: ',abtest_ProductListPricingArea);

    const url = `/cart?productid=${product.skuid}`;
    const departmentID = Number(product.departmentID) || 0;

    //Check Options touched
    const isProductOptionsSelected = useAppSelector((store) => store.isProductOptionsSelected);
    const isAddToCartUntouched = product.isProductOptions && !isProductOptionsSelected;

    // subscription + variants
    let addToCartText ='Add to Cart';
    const isSubscriptionVariants = product.isProductOptions && departmentID === ProductDepartmentEnum.Subscription;
    let isUltimateEssential = isSubscriptionVariants;

    if(isSubscriptionVariants && !props?.isPriceDifferent)
        addToCartText = 'Start Free 7-day Trial';

    if(isSubscriptionVariants && props?.isPriceDifferent)
        addToCartText = 'Subscribe Now';

    if(product.isPreorder)
        addToCartText = 'Pre-Order';

    const prodExeptions = ["SBSm010SGRCK", "SBSy010SGRCK"];
    if(prodExeptions.includes(product.skuNumber)){
        addToCartText = 'Add to Cart';
        isUltimateEssential = false;
    }

    const _href = isAddToCartUntouched ? "#" : url;

    const hasDataCartOpen = !product.isProductOptions && (
        departmentID === ProductDepartmentEnum.Plugins ||
        departmentID === ProductDepartmentEnum.Bundles
    );

    const baseBtnClass =
        abtest_ProductListPricingArea !== abtest_ProductListPricingAreaVariants.yellow_sbs
            ? 'w-btn bg-yellow-400 text-gray-700'
            : 'w-btn-outline-white';

    const isUltimateEssentialClass = `${baseBtnClass} prd-add-to-cart`;
    const isNotUltimateEssentialClass = `${baseBtnClass} w-40 lg:w-48 prd-add-to-cart`;

    const className =
        isUltimateEssential ? isUltimateEssentialClass : isNotUltimateEssentialClass;

    /**
     * https://wavesaudio.atlassian.net/browse/DSWEB-5501
     */
    useEffect(() => {
        const abtest = getABTest('AskWaves');
        if(!abtest?.isActive) return;
        sendABTestAnalytics(abtest);
        setShowAskWaves(abtest.selected === 'yes');
    }, []);

    return (
            <>

                { abtest_ProductListPricingArea !== abtest_ProductListPricingAreaVariants.perpetual_link &&
                    <div className="w-full flex flex-wrap prd-add-to-cart">

                        <div className="flex flex-col mt-4 text-center items-center">
                            <div className={`flex flex-col text-center`} data-cart={ hasDataCartOpen ? 'open' : undefined }>

                                <a href={ _href } className={className} data-skunumber={ product.skuNumber }

                                   onClick={ evt => {
                                       if(isAddToCartUntouched) {
                                           evt.preventDefault();
                                           dispatch(
                                               rootActions.main({
                                                   isProductOptionsTouched: true
                                               })
                                           );
                                       }
                                       else{
                                           sendGAEventAddToCart(
                                               product.isProductOptions ? product.skuName : product.documentName,
                                               product.skuNumber,
                                               product.skuPrice,
                                               product.documentUrlPath,
                                               'Product Add To Cart'
                                           );
                                           outbrainAddToCartEvent();
                                       }
                                   }}
                                >{addToCartText}</a>

                            </div>

                            {
                                productPageUpgradeLink > 0 &&
                                <a className="text-blue-150 mt-2" href={"/account/upgrades/"+product.upgradeTargetID}>
                                    Upgrade from <ProductPriceFormat price={productPageUpgradeLink}  />
                                </a>
                            }
                        </div>

                        {/*Subscribe button*/
                            // product.includedInSBS > 0 &&
                            // <div className={`mt-4 ml-4 dv-product-page-subscribe`}>
                            //
                            //     <a href={"/subscriptions?skus="+ product.skuid  } className="w-btn-outline-white w-40 lg:w-48" data-skunumber={ product.skuNumber }
                            //        onClick={ evt => {
                            //            sendGAEvent('Subscribe','Subscribe Button')
                            //        }}
                            //     >Subscribe</a>
                            // </div>

                            <ProductSubscribeButtonABTEST
                                productListPricingAreaVariants={abtest_ProductListPricingArea}
                                product={props?.product}
                                returnFunc={() => setShowSubscriptionPopup(true)}
                            />
                        }

                        { product.includedInSBS > 0 && !isProductNote && !showAskWaves &&
                            <PRDNeedHelpDeciding />
                        }

                        {product.expectedShipping != null &&
                            <div className="w-full">
                                <div className="expected-shipping w-max border bg-gray-800 border-gray-500 rounded text-sm lg:text-base py-2 px-2 lg:px-4 mt-4 lg:mt-4">{product.expectedShipping}</div>
                            </div>
                            }

                    </div>
                }
                { abtest_ProductListPricingArea == abtest_ProductListPricingAreaVariants.perpetual_link &&
                    <div className="w-full flex flex-col prd-add-to-cart perpetual-link">

                        <ProductSubscribeButtonABTEST
                            productListPricingAreaVariants={abtest_ProductListPricingArea}
                            product={props?.product}
                            returnFunc={() => setShowSubscriptionPopup(true)}
                        />
                        <div className="mt-4 ml-4 flex flex-wrap">or&nbsp;
                            <div className={`flex flex-col text-center`} data-cart={ hasDataCartOpen ? 'open' : undefined }>
                            <a href={_href} className="text-white underline" data-skunumber={product.skuNumber}

                               onClick={evt => {
                                   if (isAddToCartUntouched) {
                                       evt.preventDefault();
                                       dispatch(
                                           rootActions.main({
                                               isProductOptionsTouched: true
                                           })
                                       );
                                   } else {
                                       sendGAEventAddToCart(
                                           product.isProductOptions ? product.skuName : product.documentName,
                                           product.skuNumber,
                                           product.skuPrice,
                                           product.documentUrlPath,
                                           'Product Add To Cart'
                                       );
                                       outbrainAddToCartEvent();
                                   }
                               }}
                            >buy perpetual license
                            </a>
                            </div>
                            &nbsp;for&nbsp;<ProductPriceFormat price={product.skuPrice}/>
                        </div>
                    </div>
                }
                {showSubscriptionPopup &&
                    <PlansPopupExported close={() => setShowSubscriptionPopup(false)}
                                        product={props?.product as unknown as IListItem}
                                        sbsIncludedIn={props?.product.includedInSBS}
                                        needImgCDNDomain={true}/>
                }

                { showAskWaves && <ProductAskWavesBtn /> }
            </>
    )
};

export default PRDAddToCart;